import React from 'react'
import CustomNavbar from '../../../custom_components/custom_navbar/CustomNavbar'
import HeroSection from './hero_section/HeroSection'
import FeaturesSection from './feature_section/FeaturesSection'
import HospitalsSection from './hospitals_section/HospitalsSection'
import LaboratoriesSection from './laboratorie_section/LaboratoriesSection'
import AboutUsSection from './aboutUs-section/AboutUsSection'
import ContactUsAndDonation from './contactus_section/ContactUsAndDonation'
import Footer from './footer_section/Footer'
function LandingPage() {
  return (
    <>
        <CustomNavbar/>
        <HeroSection/>
        <FeaturesSection/>
        <HospitalsSection/>
        <LaboratoriesSection/>
        <AboutUsSection/>
        <ContactUsAndDonation/>
        <Footer/>
    </>
  )
}

export default LandingPage